import { Box } from "@mui/material";

/**
    * 
    * @param {Object} props
    * @param {Object} props.image
    * @param {Object} props.sx
    * @param {Number} props.width
    * @param {Number} props.height
    * @returns 
    */
export const RPMImage = ({ image, sx = {}, width = "100%", height = "auto", borderRadius = 0 }) => {
    if (!image || !image.url) return null;

    const { url, alt, dimensions } = image;
    const aspectRatio = dimensions?.width && dimensions?.height ? dimensions?.width / dimensions?.height : null;


    const style = width || height ? {  aspectRatio: aspectRatio, borderRadius  } : { maxWidth: "100%", height: "auto", aspectRatio: aspectRatio, borderRadius };

    return (
        <Box sx={sx}>
            <img
                src={url}
                alt={alt || 'Cardcam image'}
                width={width ?? dimensions.width}
                height={height ?? dimensions.height}
                style={ style }
                loading="lazy"  
                onError={(e) => { e.target.style.display = 'none' }}  // Optional: handle image load error
            />
        </Box>
    )
}